/**
 * Created by ChrisMuto on 7/7/17.
 */
import { isEmpty, isNil } from "lodash";

export function getCtaById(entities, ctaId) {
    const { ctas } = entities;
    if (isNil(ctas) || isEmpty(ctas)) {
        return null;
    }
    return ctas[ctaId];
}



// WEBPACK FOOTER //
// ./src/modules/ctas/selectors.js